<template>
  <span
    class="tag"
    :class="{
      tag__round: status === 'round',
      tag__reserved: status === 'reserved',
      tag__express: status === 'express',
    }"
  >
    {{ returnStatus() }}
  </span>
</template>
<script>
export default {
  props: ["status"],
  methods: {
    returnStatus() {
      if (this.status === "round") return "왕복";
      if (this.status === "express") return "급송";
      if (this.status === "reserved") return "예약";
      return "";
    },
  },
};
</script>
<style>
.tag {
  border-radius: 99px;
  padding: 3px 7px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-width: 35px;
  width: fit-content;
  height: 22px;
}

.tag__round {
  background-color: var(--primary-100);
  color: var(--primary-400);
}
.tag__reserved {
  background-color: var(--secondary-100);
  color: var(--secondary-400);
}
.tag__express {
  background-color: var(--red-100);
  color: var(--red-400);
}
</style>
